export default __webpack_public_path__ + "static/indasrtial_small-a234e83ec884b435eff8db9726441b84.jpg";